<div class="w-full max-w-[800px] p-0">

  <!-- Header -->
  <div style="display: flex; align-items: center; gap: 12px; padding: 20px 24px; border-bottom: 1px solid #e5e7eb;">
    <div style="background: #fef2f2; border-radius: 12px; padding: 10px; display: flex; align-items: center; justify-content: center;">
      <mat-icon style="color: #dc2626; font-size: 24px; width: 24px; height: 24px;">cancel</mat-icon>
    </div>
    <div>
      <h2 style="margin: 0; font-size: 1.2rem; font-weight: 700; color: #111827;">Rechazar Referencia</h2>
      <p style="margin: 2px 0 0 0; font-size: 0.8rem; color: #6b7280;">Rechazar carga VES pendiente</p>
    </div>
  </div>

  <!-- Info card -->
  <div style="margin: 16px 24px; padding: 16px; background: #fef2f2; border: 1px solid #fecaca; border-radius: 10px;">
    <div class="grid grid-cols-1 sm:grid-cols-2 gap-3">
      <div>
        <span style="color: #6b7280; font-size: 0.75rem; display: block;">Usuario ID</span>
        <span style="color: #2563eb; font-weight: 700; font-size: 0.9rem; font-family: monospace;">#{{ referencia.userId }}</span>
      </div>
      <div>
        <span style="color: #6b7280; font-size: 0.75rem; display: block;">Referencia</span>
        <span style="color: #111827; font-weight: 700; font-size: 0.9rem; font-family: monospace;">{{ referencia.referencia }}</span>
      </div>
      <div>
        <span style="color: #6b7280; font-size: 0.75rem; display: block;">Titular</span>
        <span style="color: #111827; font-weight: 600; font-size: 0.9rem;">{{ referencia.titular }}</span>
      </div>
      <div>
        <span style="color: #6b7280; font-size: 0.75rem; display: block;">Banco</span>
        <span style="color: #111827; font-weight: 500; font-size: 0.85rem;">{{ referencia.banco }}</span>
      </div>
      <div>
        <span style="color: #6b7280; font-size: 0.75rem; display: block;">Tipo de Cuenta</span>
        <span style="color: #111827; font-weight: 500; font-size: 0.85rem;">{{ referencia.tipoCuenta }}</span>
      </div>
      <div>
        <span style="color: #6b7280; font-size: 0.75rem; display: block;">N&uacute;mero de Cuenta</span>
        <span style="color: #111827; font-weight: 500; font-size: 0.85rem; font-family: monospace;">{{ referencia.cuenta }}</span>
      </div>

      <!-- Monto -->
      <div style="grid-column: 1 / -1; padding-top: 4px; border-top: 1px solid #fecaca;">
        <span style="color: #6b7280; font-size: 0.75rem; display: block;">Monto</span>
        <span style="color: #dc2626; font-weight: 700; font-size: 1.1rem;">{{ formatVES(referencia.monto) }}</span>
      </div>
    </div>
  </div>

  <!-- Form -->
  <div style="padding: 0 24px;" *ngIf="reasonForm">
    <form [formGroup]="reasonForm">
      <mat-form-field appearance="outline" class="w-full">
        <mat-label>Motivo del rechazo</mat-label>
        <mat-icon matPrefix style="color: #dc2626; margin-right: 8px;">report_problem</mat-icon>
        <input matInput formControlName="reason" placeholder="Ingrese el motivo del rechazo">
        <mat-error *ngIf="reasonForm.get('reason')?.hasError('required')">El motivo es requerido</mat-error>
        <mat-error *ngIf="reasonForm.get('reason')?.hasError('minlength')">M&iacute;nimo 3 caracteres</mat-error>
      </mat-form-field>
    </form>
  </div>

  <!-- Buttons -->
  <div style="display: flex; gap: 12px; padding: 20px 24px; border-top: 1px solid #e5e7eb; justify-content: flex-end;">
    <button (click)="close()"
      style="padding: 10px 24px; background: #f3f4f6; color: #374151; border: none; border-radius: 8px; font-size: 0.9rem; font-weight: 600; cursor: pointer;">
      Cancelar
    </button>
    <button (click)="reject()" [disabled]="reasonForm.invalid || loading"
      style="display: inline-flex; align-items: center; gap: 6px; padding: 10px 24px; background: #dc2626; color: white; border: none; border-radius: 8px; font-size: 0.9rem; font-weight: 600; cursor: pointer;"
      [style.opacity]="reasonForm.invalid || loading ? '0.5' : '1'">
      <mat-icon style="font-size: 18px; width: 18px; height: 18px;">cancel</mat-icon>
      Rechazar referencia
    </button>
  </div>

</div>
